import React from "react"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import FieldPositionEditor from "./FieldPositionEditor"

// Read-only look at a template: cheque image with every field positioned on it.
const TemplatePreviewModal = ({ template, ownerName, toggle }) => (
  <Modal isOpen={Boolean(template)} toggle={toggle} size="xl">
    <ModalHeader toggle={toggle}>
      {template?.bankName}
      {ownerName ? ` — ${ownerName}` : ""}
    </ModalHeader>
    <ModalBody>
      {template && (
        <div>
          <FieldPositionEditor imageUrl={template.imageUrl} leaf={template.leaf} fields={template.fields} onFieldsChange={() => {}} readOnly />
        </div>
      )}
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" outline type="button" onClick={toggle}>
        Close
      </Button>
    </ModalFooter>
  </Modal>
)

export default TemplatePreviewModal
